// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"54934c08","952":"370743b6"}[chunkId] + ".chunk.js";
};